const PHONE_PLACEHOLDER_EMAIL_DOMAIN = 'phone.musein.local';
const E164_PHONE_REGEX = /^\+[1-9]\d{6,14}$/;

export function normalizePhoneNumber(value: string): string {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return '';
  }

  const normalizedValue = trimmedValue.replace(/[\s()-]/g, '');
  if (normalizedValue.startsWith('+')) {
    return `+${normalizedValue.slice(1).replace(/\+/g, '')}`;
  }

  return normalizedValue.replace(/\+/g, '');
}

export function isValidE164Phone(value: string): boolean {
  return E164_PHONE_REGEX.test(normalizePhoneNumber(value));
}

export function isPhonePlaceholderEmail(email?: string | null): boolean {
  if (!email) {
    return false;
  }

  return email.toLowerCase().endsWith(`@${PHONE_PLACEHOLDER_EMAIL_DOMAIN}`);
}

export function extractPhoneDigitsFromPlaceholderEmail(email?: string | null): string | null {
  if (!isPhonePlaceholderEmail(email)) {
    return null;
  }

  const [localPart = ''] = (email ?? '').split('@');
  return /^\d{7,15}$/.test(localPart) ? localPart : null;
}

export function maskPhoneDigitsForDisplay(digits: string): string {
  if (!digits) {
    return '';
  }

  if (digits.length <= 7) {
    return `+${digits}`;
  }

  const visiblePrefixLength = Math.min(3, Math.max(1, digits.length - 4));
  const visiblePrefix = digits.slice(0, visiblePrefixLength);
  const visibleSuffix = digits.slice(-4);
  const maskedLength = Math.max(4, digits.length - visiblePrefixLength - 4);

  return `+${visiblePrefix}${'*'.repeat(maskedLength)}${visibleSuffix}`;
}

export function getUserContactDisplay(user?: {
  phone?: string | null;
  email?: string | null;
} | null): string {
  if (!user) {
    return '';
  }

  if (user.phone && isValidE164Phone(user.phone)) {
    return maskPhoneDigitsForDisplay(normalizePhoneNumber(user.phone).slice(1));
  }

  const placeholderDigits = extractPhoneDigitsFromPlaceholderEmail(user.email);
  if (placeholderDigits) {
    return maskPhoneDigitsForDisplay(placeholderDigits);
  }

  return user.email?.trim() ?? '';
}
